import createDuck from '../../../lib/ducks/bannerDuck'

export default createDuck({
  store: 'alertCredits',
})
